/**
 * Authenticated fetch wrapper that includes both cookies and Authorization header
 * for maximum compatibility with the backend authentication middleware
 */

const getAuthHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  // Try to get token from localStorage or sessionStorage
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  
  // Add Authorization header if token exists
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

const authFetch = async (url, options = {}) => {
  // Prepare headers with auth
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };
  
  // Ensure credentials are included for cookie-based auth
  const fetchOptions = {
    ...options,
    headers,
    credentials: 'include', // Always include cookies
  };
  
  return fetch(url, fetchOptions);
};

// Export both the fetch wrapper and header utility
export default authFetch;
export { getAuthHeaders };
